import { nanoid } from 'nanoid'

import { ImageDto } from '@wwt/entities/api/search-response'

export const addIdToImages = (images?: ImageDto[]) => {
	if (!images) {
		return []
	}

	return images.map(image => {
		return {
			...image,
			id: nanoid()
		}
	})
}
